import { render, staticRenderFns } from "./SubscriptionsTable.vue?vue&type=template&id=5a6fde19"
import script from "./SubscriptionsTable.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports